import { createClient } from "@supabase/supabase-js";
import { SUPABASE_KEY, SUPABASE_URL } from "./config";

// The training lead signs in with an emailed link (plan decision 14). The link comes
// back with the session in the address, which supabase-js reads and then clears.
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: { flowType: "implicit", detectSessionInUrl: true, persistSession: true },
});

/** A readable message from a Supabase or network error. */
export function errorText(error: unknown): string {
  if (!error) return "";
  if (typeof error === "string") return error;
  if (error instanceof Error) return error.message;
  const e = error as { message?: string; error?: string };
  return e.message ?? e.error ?? "Something went wrong. Please try again.";
}
